var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 159,
    height: 159,
    viewBox: "0 0 159 159",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_103_8537)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 79.2,
    cy: 79.2,
    r: 74.7,
    fill: "#1865F2",
    stroke: "white",
    strokeWidth: 9
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.3526 34.5748C74.508 27.9413 83.8925 27.9413 86.0478 34.5748L92.3343 53.9225C93.2982 56.8891 96.0627 58.8976 99.1819 58.8976H119.525C126.5 58.8976 129.4 67.8228 123.757 71.9225L107.299 83.8801C104.776 85.7135 103.72 88.9633 104.684 91.9299L110.97 111.278C113.125 117.911 105.533 123.427 99.8905 119.327L83.4323 107.37C80.9088 105.536 77.4917 105.536 74.9682 107.37L58.51 119.327C52.8673 123.427 45.275 117.911 47.4304 111.278L53.7168 91.9299C54.6807 88.9633 53.6248 85.7135 51.1013 83.8801L34.6431 71.9225C29.0003 67.8228 31.9003 58.8976 38.8752 58.8976H59.2186C62.3378 58.8976 65.1023 56.8891 66.0662 53.9225L72.3526 34.5748Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_103_8537"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 158.4,
    height: 158.4,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarIcon);
export default __webpack_public_path__ + "static/media/star-icon.28178e32682ba4ab5194aad3bbc8d23e.svg";
export { ForwardRef as ReactComponent };